export type EditorOptions = {
  toolbar?: {
    showOnSelection?: boolean;
    followSelection?: boolean;
  };
};

export const defaultEditorOptions: EditorOptions = {
  toolbar: {
    showOnSelection: false,
    followSelection: true,
  },
};
